import { useState } from 'react';

import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import IconButton from '@material-ui/core/IconButton';
import { BumpResourceSheetDto } from '@vatos-pas/common';
import NotesIcon from '@material-ui/icons/Note';
import NotesAddIcon from '@material-ui/icons/NoteAdd';

import { CAN_EDIT_BUMPOUT_TIMESHEET_NOTES } from 'providers/permissions';
import { PermissionsProvider } from 'providers/permissionsProvider';
import { NotesManagementDialog } from './NotesManagementDialog';

type NotesButtonProps = PublicFieldProps &
  InjectedFieldProps<BumpResourceSheetDto>;

const NotesButton = ({ record }: NotesButtonProps) => {
  if (!record?.id) return null;

  const { hasPermission } = PermissionsProvider.useContainer();

  const [isNotesManagementOpen, setIsNotesManagementOpen] = useState(false);

  const canEditNote = hasPermission(CAN_EDIT_BUMPOUT_TIMESHEET_NOTES);
  if (!record.hasNotes && !canEditNote) return null;

  return (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={() => setIsNotesManagementOpen(true)}
      >
        {record.hasNotes ? <NotesIcon /> : <NotesAddIcon />}
      </IconButton>
      <NotesManagementDialog
        open={isNotesManagementOpen}
        record={record}
        handleClose={() => setIsNotesManagementOpen(false)}
      />
    </>
  );
};

export default NotesButton;
